module.exports = __webpack_public_path__ + "img/madeinfrance.6b290ee8.png";